module.exports = __webpack_public_path__ + "img/pass-showing-barcode.b8720fcc.svg";